import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 19.7 19.7"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.6.7 13 1.8l1.9.2c1.4.2 2.6 1.3 2.7 2.8l.2 1.8 1.1 1.3c1 1.1.9 2.7 0 3.8l-1.1 1.4-.2 1.9c-.2 1.3-1.2 2.6-2.7 2.7l-1.7.3-1.4 1.1c-1.1.9-2.7.9-3.8 0L6.5 18l-1.8-.3c-1.4-.2-2.6-1.3-2.7-2.8l-.2-1.8-1.1-1.3C-.2 10.7-.2 9.1.7 8l1.1-1.4.2-1.8C2.2 3.3 3.3 2.3 4.6 2h.1l1.8-.2L7.8.7c1.1-.9 2.7-.9 3.8 0M3.1 7.3 1.9 8.9c-.4.5-.5 1.3 0 1.9l1.2 1.5c.1.1.1.2.2.4l.2 2c.1.7.6 1.3 1.5 1.4l2 .3c.1 0 .2.1.3.1l1.6 1.2c.6.5 1.4.5 1.9 0l1.6-1.2c.1-.1.2-.1.3-.1l1.9-.3c.7-.1 1.3-.6 1.4-1.5l.3-2c0-.1.1-.2.1-.3l1.2-1.6c.5-.6.5-1.4 0-1.9l-1.3-1.5c-.1-.1-.2-.3-.2-.4l-.2-2c-.1-.7-.6-1.3-1.5-1.4l-2-.3c-.1 0-.2-.1-.3-.1l-1.6-1.2c-.6-.5-1.4-.5-1.9 0L7.3 3.1c-.2.1-.3.2-.5.2l-2 .2c-.7.2-1.2.7-1.3 1.4L3.2 7c0 .1-.1.2-.1.3",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12.9 8.1c.2.2.2.5 0 .7l-3.5 3.5c-.2.2-.5.2-.7 0l-2.1-2.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0L9 11.2l3.1-3.1c.3-.2.6-.2.8 0",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }